export default __webpack_public_path__ + "static/media/Group 8545.431ac5d7.png";